import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
// Container
import Container from "./styled";
// Iconos
import { BsWhatsapp } from "react-icons/bs";
// Librerias
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import "tippy.js/animations/scale-subtle.css";
import "tippy.js/animations/scale-extreme.css";
import NumberFormat from "react-number-format";
// Animaciones
import AnimacionBicicleta from "./ilustracion-animada-bici";
import AnimacionMonopatin from "./ilustracion-animada-monopatin";
import AnimacionCarga from "./animacion-carga";
// Otros
import axios from "axios";
import url from "../../utils/url";
import ReactGa from "react-ga";
import { formatter } from "../../utils/formatter";

export default function Cotizador({
  subtitle,
  landingVehiculo,
  marketing_url,
  bicicleteria,
  bicicleteriaId,
  logo,
  isReferidosHeaderOpen,
  esBicicleteria,
}) {
  // Estado para el loading
  const [loading, setLoading] = useState(false);
  // Valores de los inputs
  const [inputValues, setInputValues] = useState({
    nombre:
      localStorage.getItem("segurobici-nombre") !== null
        ? localStorage.getItem("segurobici-nombre")
        : "",
    apellido:
      localStorage.getItem("segurobici-apellido") !== null
        ? localStorage.getItem("segurobici-apellido")
        : "",
    email:
      localStorage.getItem("segurobici-email") !== null
        ? localStorage.getItem("segurobici-email")
        : "",
    provincia:
      localStorage.getItem("segurobici-provincia") !== null
        ? localStorage.getItem("segurobici-provincia")
        : "",
    codigoPostal:
      localStorage.getItem("segurocomercio-codigoPostal") !== null
        ? localStorage.getItem("segurocomercio-codigoPostal")
        : "",
    telefono:
      localStorage.getItem("segurobici-telefono") !== null
        ? localStorage.getItem("segurobici-telefono")
        : "",
    codigoArea:
      localStorage.getItem("segurobici-codigoArea") !== null
        ? localStorage.getItem("segurobici-codigoArea")
        : "",
    vehiculo: "bicicletas"
  });
  // Errores del formulario
  const [formErrors, setFormErrors] = useState({});
  // Pop-up Errores
  const [popupErrores, setPopupErrores] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  // Valores dinámico del rango del cotizador
  const [rangeval, setRangeval] = useState(50000);
  const [valueLimit, setValueLimit] = useState(null);
  const [valueLimitFormatted, setValueLimitFormatted] = useState(null);
  const [cotizadorLimite, setCotizadorLimite] = useState({})

  const pathname = location.pathname
  
  const VEHICULO_LABELS = {
    bicicletas: "Bicicleta",
    bici_uso_comercial: "Bicicleta (Delivery)",
    bicicletas_eléctricas: "Bicicleta Eléctrica",
    monopatin: "Monopatín Eléctrico"
  }
  
  // Nombre Bicicleterias
  const nombreBicicleteria = useParams();

  console.log(location)

  // Marketing URL
  useEffect(() => {
    if (marketing_url) {
      document.title = marketing_url.title_marketing_url;
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", marketing_url.description_marketing_url);
    }
  }, [marketing_url]);

  // Estilos del input de rango para setear el valor de la bici
  for (let e of document.querySelectorAll(".sliderProgress")) {
    /*
    if (
      (e.value > 570000 && inputValues.vehiculo === "bicicleta electrica") ||
      (e.value > 500000 && inputValues.vehiculo === "bicicleta (delivery)")
    ) {
      e.value = 50000;
    }
    */
    /*
    if (
      (e.value > 172000 && inputValues.vehiculo === "bicicleta (delivery)") ||
      (e.value > 225000 && inputValues.vehiculo === "monopatin electrico")
    ) {
      e.value = 50000;
    }
    */
    e.style.setProperty("--value", e.value);
    e.style.setProperty("--min", e.min == "" ? "0" : e.min);
    e.style.setProperty("--max", e.max == "" ? "100" : e.max);
    e.addEventListener("input", () => e.style.setProperty("--value", e.value));
  }

  // Params provenientes de la URL
  const [searchParams, setSearchParams] = useSearchParams();
  const [ip, setIp] = useState("");
  const utm_source = searchParams.get("utm_source");
  const utm_medium = searchParams.get("utm_medium");
  const utm_campaign = searchParams.get("utm_campaign");
  const fb_id = searchParams.get("fbclid");
  const influencer = searchParams.get("influencer")
    ? searchParams.get("influencer")
    : 0;
  const [canal_url, setCanal_url] = useState(null);
  // Network Params
  const network = searchParams.get("network");
  const networkCampaign = searchParams.get("campaign");
  const networkGroup = searchParams.get("group");
  const networkCreative = searchParams.get("creative");
  const networkKeyword = searchParams.get("keyword");
  const networkDevice = searchParams.get("device");
  const networkMatchtype = searchParams.get("matchtype");
  const networkClid = searchParams.get("gclid");

  // Obtiene la IP del usuario
  useEffect(() => {
    const data = async () => {
      const res = await axios.get("https://geolocation-db.com/json/");
      setIp(res.data.IPv4);
    };
    data();

    // Obtiene la ruta desde la que se ingresá (canales)
    const url = window.location.toString().split("/");
    const sufijo = url[url.length - 1];

    if(pathname === "/asap-consulting"){
      setCanal_url(179)
    } else {
      let canal;
      switch (sufijo) {
        case "gs":
          canal = 1;
          break;
        case "gd":
          canal = 2;
          break;
        case "in":
          canal = 38;
          break;
        case "fb":
          canal = 7;
          break;
        case "tiktok":
          canal = 135;
          break;
        case "twitch":
          canal = 141;
          break;
        default:
          canal = null;
          break;
      }
      setCanal_url(canal);
    }


  }, []);

  // Canales
  let canal;
  let msjSegunCanal = () => {
    if (
      utm_source == "face" ||
      utm_source == "Face" ||
      utm_source == "facebook" ||
      utm_source == "Facebook" ||
      utm_source == "FacebookPerfil" ||
      utm_source == "FacebookInbox" ||
      utm_source == "FacebookPost" ||
      utm_source == "FacebookStory"
    ) {
      canal = "Facebook";
    } else if (
      utm_source == "Instagram" ||
      utm_source == "instagram" ||
      utm_source == "Insta" ||
      utm_source == "insta" ||
      utm_source == "IG" ||
      utm_source == "ig" ||
      utm_source == "InstagramPerfil" ||
      utm_source == "InstagramInbox" ||
      utm_source == "InstagramStories"
    ) {
      canal = "instagram";
    } else if (
      utm_source == "google" ||
      utm_source == "Google" ||
      network == "g" ||
      network == "d" ||
      network == "r"
    ) {
      canal = "Google";
    } else if (utm_source == "mail" || utm_source == "Mail") {
      canal = "el e-mail";
    } else if (utm_source == "inbound" || utm_source == "Inbound") {
      canal = "inbound";
    } else if (utm_medium == "youtube" || utm_medium == "Youtube") {
      canal = "YouTube";
    } else if (utm_medium == "blog" || utm_medium == "Blog") {
      canal = "el Blog";
    } else if (
      utm_source == "twitter" ||
      utm_source == "Twitter" ||
      utm_source == "TwitterPost"
    ) {
      canal = "Twitter";
    } else if (utm_source == "emblue" || utm_source == "emBlue") {
      canal = "emBlue";
    } else if (utm_source == "Autogestion" || utm_source == "autogestion") {
      canal = "autogestión";
    } else canal = "la Web";

    return `https://api.whatsapp.com/send?phone=5491164358739&text=%C2%A1Hola%2C%20necesito%20ayuda%20para%20cotizar%20una%20bicicleta!%20Ingresé%20desde%20${canal}`;
  };

  // Obtener prefijos de la base para validar en conjunto con el ingresado por el usuario.
  useEffect(() => {
    const getValoresCotizador = async () => {
      try {
        const valores = await axios.get(`${url}/api/valores_productos_cotizador`)
        console.log(valores, 'esto es valores')
        const bicicleta = valores.data.find(valores => valores.descripcion === "Bicicletas")
        setValueLimit(bicicleta.limite_cotizador);
        setValueLimitFormatted(`$${formatter.format(bicicleta.limite_cotizador)}`);
        setCotizadorLimite(valores.data)
      } catch (error) {
        console.log("Hubo un error", error);
      }
    };
    getValoresCotizador();
  }, []);

  // Setea el valor de los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prev) => ({ ...prev, [name]: value }));
    // Guarda el valor de cada input en el localStorage
    localStorage.setItem("segurobici-" + [name], value);
  };

  // Validar formulario
  const validateForm = (e) => {
    localStorage.setItem("segurobici-vehiculo", inputValues.vehiculo);
    e.preventDefault();
    let errors = {};
    let cobertura;

    // Validar Nombre
    if (!inputValues.nombre) {
      errors.nombre = "Este campo es requerido.";
    } else if (inputValues.nombre.length < 2) {
      errors.nombre = "El campo nombre debe contener al menos 2 caracteres.";
    } else if (
      !/^[a-zA-Z\u00C0-\u017F!@#$%^&':"\\|,.<>\/?\s\u00f1\u00d1]*$/.test(
        inputValues.nombre
      )
    ) {
      errors.nombre = "El nombre ingresado no es válido.";
    }

    // Validar Apellido
    if (!inputValues.apellido) {
      errors.apellido = "Este campo es requerido.";
    } else if (inputValues.apellido.length < 2) {
      errors.apellido =
        "El campo apellido debe contener al menos 2 caracteres.";
    } else if (
      !/^[a-zA-Z!@#$%^&':"\\|,.<>\/?\s\u00f1\u00d1]*$/.test(
        inputValues.apellido
      )
    ) {
      errors.apellido = "El apellido ingresado no es válido.";
    }

    if (!inputValues.email) {
      errors.email = "Este campo es requerido.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValues.email)) {
      errors.email = "El email ingresado no es valido.";
    }

    // Validar Provincia
    if (!inputValues.provincia) {
      errors.provincia = "Este campo es requerido.";
    }

    // Validar código postal
    if (!inputValues.codigoPostal) {
      errors.codigoPostal = "El código postal es requerido";
    } else if (
      inputValues.codigoPostal.length <= 3
    ) {
      errors.codigoPostal =
        "El código postala debe tener al menos 4 caracteres";
    }

    // Validar Teléfono
    if (!inputValues.telefono) {
      errors.telefono = "Este campo es requerido.";
    } else if (inputValues.telefono.length < 7) {
      errors.telefono = "El campo telefono es menor a 7 digitos.";
    }

    // Validar Código de área
    if (!inputValues.codigoArea) {
      errors.codigoArea = "Este campo es requerido.";
    } else if (
      inputValues.codigoArea.length < 2 ||
      inputValues.codigoArea.length > 5
    ) {
      errors.codigoArea =
        "El código de área debe tener más de 2 digitos y menos de 5.";
    }

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      ReactGa.event({
        category: "Cotizar",
        action: "Click",
      });
      localStorage.setItem("segurobici-sumaasegurada", rangeval);
      setLoading(true);
      sendData();
    }
  };

  // Medición de clicks
  let medicionClick = () => {
    ReactGa.event({
      category: "WhatsApp",
      action: "Click",
    });
  };

  // Envia la data al back
  const sendData = async () => {
    const origen = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent
    )
      ? "mobile"
      : "web";
    const landing_url = window.location.href.split("/");
    let landing;
    let tipo;

    if (
      landing_url[3] === "bicicleta-electrica" ||
      inputValues.vehiculo === "bicicleta electrica"
    ) {
      landing = "electrica";
      tipo = "electrica";
    } else if (
      landing_url[3] === "monopatin-electrico" ||
      inputValues.vehiculo === "monopatin" ||
      inputValues.vehiculo === "monopatin electrico"
    ) {
      landing = "monopatin";
      tipo = "monopatin";
    } else if (
      landing_url[3] === "comercial" ||
      inputValues.vehiculo === "bicicleta (delivery)"
    ) {
      landing = "comercial";
      tipo = "comercial";
    } else if (
      landing_url[3] === "seguro-de-bicicleta" ||
      inputValues.vehiculo === "bicicleta"
    ) {
      landing = "seguro-de-bicicleta";
      tipo = "comun";
    } else {
      landing = "bici";
      tipo = "comun";
    }

    // Data
    const data = {
      nombre: `${inputValues.nombre} ${inputValues.apellido}`,
      email: inputValues.email,
      valor: rangeval,
      prefijo: inputValues.codigoArea,
      telefono: inputValues.telefono,
      provincia: inputValues.provincia,
      codigo_postal: inputValues.codigoPostal,
      vehiculo: inputValues.vehiculo,
      tipoDeVehiculo: inputValues.tipoDeVehiculo,
      utm_source: utm_source ? utm_source : "",
      utm_medium: utm_medium ? utm_medium : "",
      utm_campaign: utm_campaign ? utm_campaign : "",
      landing: bicicleteria != null ? "bicicleterias" : "landing",
      origen: origen,
      tipo: tipo,
      marca: "",
      extra: "",
      bicicleteria: bicicleteriaId != null ? bicicleteriaId : "",
      delivery: "",
      ip_address: ip,
      landing_url: landing_url[3],
      url_ingreso: window.location.href,
      influencer: influencer,
      fb_id: fb_id,
      network: network,
      networkCampaign: networkCampaign,
      networkGroup: networkGroup,
      networkCreative: networkCreative,
      networkKeyword: networkKeyword,
      networkDevice: networkDevice,
      networkMatchtype: networkMatchtype,
      networkClid: networkClid,
      canal_url: canal_url,
    };

    console.log(data)

    const post = await axios.post(`${url}/api/valores`, data);
    if (post.status === 200) {
      navigate(`/pasos/?op=${post.data.numero}`, { state: post.data });
    }
  };

  // Select Vehículo
  const selectVehiculo = (name, value) => {
    handleChange(name, value);
    if (
      inputValues.vehiculo == "bicicleta" ||
      inputValues.vehiculo == "bicicleta (delivery)" ||
      inputValues.vehiculo == "bicicleta electrica"
    ) {
      inputValues.tipoDeVehiculo = "bicicleta";
    } else if (
      inputValues.vehiculo == "monopatin" ||
      inputValues.vehiculo == "monopatin electrico"
    ) {
      inputValues.tipoDeVehiculo = "monopatin";
    }
  };

  // Cambian valores dinámicos
  useEffect(() => {
    if (inputValues.vehiculo && cotizadorLimite.length > 0 && valueLimit) {
      const producto = cotizadorLimite.find(limite => limite.descripcion.toLowerCase().replaceAll(" ", "_") === inputValues.vehiculo)
      setValueLimit(producto.limite_cotizador);
      setValueLimitFormatted(`$${formatter.format(producto.limite_cotizador)}`);
    }
  }, [inputValues.vehiculo, cotizadorLimite, valueLimit]);

  return (
    <Container
      esBicicleteria={esBicicleteria}
      isReferidosHeaderOpen={isReferidosHeaderOpen}
      name="cotizador"
    >
      {/* Formulario Container */}
      <div id="form-titulo-container" className="opacidad05">
        {/* Titulos */}
        <div id="titulos-logo-container">
          {/* Bicicletaria Logo Container */}
          {logo != null ? 
            <div id="bicicleteria-logo-container">
              <img src={logo} alt="Logo de bicicletería"></img>
            </div>
          : null}

          {pathname === "/asap-consulting" ?
            <div id="bicicleteria-logo-container">
              <img src="/images/logos/asap_consulting.svg" alt="Logo de ASAP Consulting"></img>
            </div>
          : null}

          <div id="titulos-container">
            <h1 className="opacidad05">
              {!marketing_url
                ? "¡Cotizá tu seguro!"
                : marketing_url.h1_marketing_url
                ? marketing_url.h1_marketing_url
                : "¡Cotizá tu seguro!"}
            </h1>
            <h3 className="opacidad05">
              {!marketing_url
                ? subtitle
                : marketing_url.h2_marketing_url
                ? marketing_url.h2_marketing_url
                : subtitle}
            </h3>
          </div>
        </div>
        {/* Formulario Container */}
        <div id="form-container" className="opacidad05">
          {/* Formulario */}
          <form>
            {/* Inputs Container */}
            <div id="inputs-container">
              {/* Input Nombre */}
              <div className="input-container" id="input-nombre-container">
                <input
                  type="text"
                  id="input-nombre"
                  name="nombre"
                  onChange={handleChange}
                  onFocus={handleChange}
                  onBlur={handleChange}
                  value={inputValues.nombre}
                  className={formErrors.nombre == null ? "" : "input-error"}
                  placeholder="Nombre"
                ></input>
              </div>
              {/* Input Apellido */}
              <div className="input-container" id="input-apellido-container">
                <input
                  type="text"
                  id="input-apellido"
                  name="apellido"
                  onChange={handleChange}
                  onFocus={handleChange}
                  onBlur={handleChange}
                  value={inputValues.apellido}
                  className={formErrors.apellido == null ? "" : "input-error"}
                  placeholder="Apellido"
                ></input>
              </div>
              {/* Input Email */}
              <div className="input-container" id="input-email-container">
                <input
                  type="email"
                  id="input-email"
                  name="email"
                  onChange={handleChange}
                  onFocus={handleChange}
                  onBlur={handleChange}
                  value={inputValues.email}
                  className={formErrors.email == null ? "" : "input-error"}
                  placeholder="Email"
                ></input>
              </div>
              {/* Input Codigo de Area */}
              <div className="input-container" id="input-codigo-area-container">
                <input
                  type="number"
                  name="codigoArea"
                  id="input-codigo-area"
                  onChange={handleChange}
                  onFocus={handleChange}
                  onBlur={handleChange}
                  value={inputValues.codigoArea}
                  className={formErrors.codigoArea == null ? "" : "input-error"}
                  placeholder="Cód. Área"
                ></input>
              </div>
              {/* Input Telefono */}
              <div className="input-container" id="input-telefono-container">
                <input
                  type="number"
                  id="input-telefono"
                  name="telefono"
                  onChange={handleChange}
                  onFocus={handleChange}
                  onBlur={handleChange}
                  value={inputValues.telefono}
                  className={formErrors.telefono == null ? "" : "input-error"}
                  placeholder="Teléfono"
                ></input>
              </div>
              {/* Provincia */}
              <div className="select-container" id="select-provincia-container">
                <select
                  id="select-provincia"
                  name="provincia"
                  value={inputValues.provincia}
                  onChange={handleChange}
                  onFocus={handleChange}
                  onBlur={handleChange}
                  className={formErrors.provincia == null ? "" : "input-error"}
                  placerholder="Provincia"
                >
                  <option value="" disabled>Provincia</option>
                  <option value="Buenos Aires">Buenos Aires</option>
                  <option value="Capital Federal">Capital Federal</option>
                  <option value="Catamarca">Catamarca</option>
                  <option value="Chaco">Chaco</option>
                  <option value="Chubut">Chubut</option>
                  <option value="Cordoba">Córdoba</option>
                  <option value="Corrientes">Corrientes</option>
                  <option value="Entre Rios">Entre Rios</option>
                  <option value="Formosa">Formosa</option>
                  <option value="Jujuy">Jujuy</option>
                  <option value="La Pampa">La Pampa</option>
                  <option value="La Rioja">La Rioja</option>
                  <option value="Mendoza">Mendoza</option>
                  <option value="Misiones">Misiones</option>
                  <option value="Neuquen">Neuquén</option>
                  <option value="Rio Negro">Río Negro</option>
                  <option value="Salta">Salta</option>
                  <option value="San Juan">San Juan</option>
                  <option value="San Luis">San Luis</option>
                  <option value="Santa Cruz">Santa Cruz</option>
                  <option value="Santa Fe">Santa Fé</option>
                  <option value="Santiago del Estero">
                    Santiago del Estero
                  </option>
                  <option value="Tierra del Fuego">Tierra del Fuego</option>
                  <option value="Tucuman">Tucumán</option>
                </select>
                <div className="flecha-select-container">
                  <i></i>
                </div>
              </div>
              {/* Input Codigo Postal */}
              <div className="input-container" id="input-codigo-postal-container">
                <input
                  type="number"
                  name="codigoPostal"
                  id="input-codigo-postal"
                  onChange={handleChange}
                  onFocus={handleChange}
                  onBlur={handleChange}
                  value={inputValues.codigoPostal}
                  className={formErrors.codigoPostal == null ? "" : "input-error"}
                  placeholder="Cód. Postal"
                ></input>
              </div>
              {/* Vehiculo */}
              {landingVehiculo == "segurodebicicleta" ||
              landingVehiculo == "comercial" ||
              landingVehiculo == "electrica" ||
              landingVehiculo == "monopatin" ? null : (
                <div
                  className="select-container"
                  id="select-vehiculo-container"
                >
                  <select
                    id="select-vehiculo"
                    name="vehiculo"
                    value={inputValues.vehiculo}
                    onChange={selectVehiculo}
                    onFocus={selectVehiculo}
                    onBlur={selectVehiculo}
                    onClick={selectVehiculo}
                    className={formErrors.vehiculo == null ? "" : "input-error"}
                    placeholder="Vehículo"
                  >
                    <option value="bicicletas">Bicicleta</option>
                    <option value="bici_uso_comercial">
                      Bicicleta (Delivery)
                    </option>
                    <option value="bicicletas_eléctricas">
                      Bicicleta eléctrica
                    </option>
                    <option value="monopatin">
                      Monopatín eléctrico
                    </option>
                  </select>
                  <div className="flecha-select-container">
                    <i></i>
                  </div>
                </div>
              )}
            </div>

            {/* Valor Bici Container*/}
            {valueLimit ?
            <div id="valor-de-bici-container">
              <p>
                {inputValues.vehiculo != "monopatin"
                  ? "Valor de la bicicleta"
                  : "Valor del monopatín"}
              </p>
              <NumberFormat
                value={rangeval}
                className="foo"
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
                renderText={(value, props) => <p {...props}>{value}</p>}
              />
              {/* Input Range */}
              <input
                type="range"
                id="inputValorBici"
                name="valorBici"
                step={
                  inputValues.vehiculo === "bicicleta (delivery)"
                    ? "2000"
                    : "5000"
                }
                min="20000"
                max={valueLimit}
                defaultValue="50000"
                onChange={(event) => setRangeval(event.target.value)}
                className="sliderProgress"
              ></input>
              <p>$20,000</p>
              <p id="valor-producto">{valueLimitFormatted}</p>
            </div>
            : null}
            {/* Botones Container */}
            <div id="botones-container">
              {/* Whatsapp Button */}
              <Tippy content="Comunicate por urgencias o en días no laborales" animation="scale">
                <a
                  href={msjSegunCanal(utm_source, network)}
                  target="_blank"
                  onClick={medicionClick}
                >
                  <span>
                    <BsWhatsapp />
                  </span>
                  Necesito ayuda
                </a>
              </Tippy>
              {/* Cotizar Button */}
              <button
                type="submit"
                onClick={validateForm}
                className="submit-button"
              >
                Cotizá tu seguro
                <img
                  alt="Ícono vehículo"
                  src={
                    process.env.PUBLIC_URL +
                    "/images/home/cotizador/iconcotizador.svg"
                  }
                ></img>
              </button>
            </div>
            <hr />
            <span className="aclaracion">
              Indicá el valor de tu {VEHICULO_LABELS[inputValues.vehiculo]} según la factura de compra. Si tu {VEHICULO_LABELS[inputValues.vehiculo]} es nueva (hasta 30 días desde la fecha de adquisición), podés informar el valor de la factura o presentar un presupuesto de Mercado Libre o de una bicicletería.
            </span>
            {/* Loading Container */}
            {loading ? (
              <div id="loading-container" className="opacidad03">
                <div id="animacion-loading">
                  <AnimacionCarga></AnimacionCarga>
                </div>
              </div>
            ) : (
              <></>
            )}
          </form>
        </div>
      </div>
      {/* Animacion Container */}
      <div id="animacion-container" className="opacidad08">
        {/* Animacion */}
        {landingVehiculo == "monopatin" ? (
          <AnimacionMonopatin></AnimacionMonopatin>
        ) : (
          <AnimacionBicicleta></AnimacionBicicleta>
        )}
      </div>
    </Container>
  );
}
